/* globals require, __dirname, process, module */
const path = require('path'),
	fs = require('fs'),
	config = JSON.parse(fs.readFileSync(path.join(__dirname, '../config/', process.env.NODE_BUILD_ENV + '.json'), 'UTF-8')),
	version = fs.readFileSync(path.join(__dirname, '../../', '.app-version'), 'UTF-8');

config.version = version;

module.exports = config;